import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { NavList, NavItem } from './Nav.styles';

const Nav = ({ closeMenu }) => {
  const INITIAL_STATE = {
    hero: false,
    superAgent: false,
    dataEngineering: false,
  };

  const [scrollPos, setScrollPos] = useState(INITIAL_STATE);
  const location = useLocation();
  const navigate = useNavigate();

  const goHome = async () => {
    await setScrollPos({ ...INITIAL_STATE, hero: true });
    if (location.pathname !== '/') {
      await navigate('/');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    await closeMenu(false);
  };

  useEffect(() => {
    if (location.pathname === '/super-agent') {
      setScrollPos({ ...INITIAL_STATE, superAgent: true });
      window.scrollTo({ top: 0 });
    }
    if (location.pathname === '/data-engineering') {
      setScrollPos({ ...INITIAL_STATE, dataEngineering: true });
      window.scrollTo({ top: 0 });
    }
    if (location.pathname === '/') {
      setScrollPos({ ...INITIAL_STATE, hero: true });
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <NavList>
      <NavItem $active={scrollPos.hero} onClick={goHome}>
        <div>Home</div>
      </NavItem>
      <NavItem $active={scrollPos.superAgent}>
        <Link to="/super-agent">Super Agent</Link>
      </NavItem>
      <NavItem $active={scrollPos.dataEngineering}>
        <Link to="/data-engineering">Data Engineering</Link>
      </NavItem>
    </NavList>
  );
};

Nav.propTypes = {
  closeMenu: PropTypes.func.isRequired,
};

export default Nav;
